import { ExecutiveAssociateDto } from './executive-associate.model';

export interface BusinessPersonDto {
  emailAddresses?: { emailAddress: string; isSelected?: boolean; isPrimary?: boolean }[];
}

export interface PassengerDto {
  readonly passengerId: number; // PK
  readonly personId: number;
  readonly businessPersonId: number;
  readonly defaultBusinessCategoryId?: number;
  readonly defaultDepartmentId?: number;
  businessPerson?: BusinessPersonDto;
  emailAddress?: string;
  firstName: string;
  lastName: string;
  middleName: string;
  suffix: string;
  initials: string;
  phoneCode?: string;
  phoneNumber?: string;
  executiveAssociates: ExecutiveAssociateDto[];
  reserved: boolean;
  birthdate: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function instanceOfPassengerDto(obj: any): obj is PassengerDto {
  if (obj && typeof obj === 'object') {
    return 'passengerId' in obj;
  }

  return false;
}
